import React from 'react';
import './About.css';
import advocateProfile from '../../assets/images/advocate-profile.jpg';

const About: React.FC = () => {
  return (
    <section className="about section" id="about">
      <div className="about-layout">
        <div className="about-panel">
          <span className="about-kicker">About us</span>
          <h2 className="about-heading">
            <span className="about-heading-line">We’re</span>
            <span className="about-heading-line">experience in</span>
            <span className="about-heading-line accent">law solution.</span>
          </h2>

          <div className="about-quote">
            <span className="quote-mark">“</span>
            <p>
              About our law firm
            </p>
          </div>

          <p className="about-description">
            Welcome to Advocate Kannan, one of the leading law firms in coimbatore, india– we offer
            you a wide range of legal services to help you through the hurdles of the legal
            system. We have an exclusive team of expert lawyers specialized in civil law,
            property law, consumer law, arbitration law, criminal law, drt cases, chit fund
            cases, insurance law, banking law, and electricity law.
          </p>

          <div className="about-highlights">
            <div className="highlight-item">
              <div className="highlight-icon" aria-hidden="true">
                <svg viewBox="0 0 32 32" role="img" aria-label="Recognition">
                  <path d="M16 4.588l2.833 8.719H28l-7.416 5.387 2.832 8.719L16 22.023l-7.417 5.39 2.833-8.719L4 13.307h9.167z" />
                </svg>
              </div>
              <span className="highlight-label">Industry Recognition</span>
            </div>
            <div className="highlight-item">
              <div className="highlight-icon" aria-hidden="true">
                <svg viewBox="0 0 32 32" role="img" aria-label="Trophy">
                  <path d="M8 6h16v4a6 6 0 0 1-5 5.91V18h3v2H10v-2h3v-2.09A6 6 0 0 1 8 10z" />
                  <path d="M6 6v3a5 5 0 0 0 3.5 4.77 8 8 0 0 1-5.5-7.77z" />
                  <path d="M26 6v3a5 5 0 0 1-3.5 4.77 8 8 0 0 0 5.5-7.77z" />
                  <rect x="10" y="22" width="12" height="2" rx="1" />
                  <rect x="12" y="24" width="8" height="2" rx="1" />
                </svg>
              </div>
              <span className="highlight-label">Award-Winning Team</span>
            </div>
            <div className="highlight-item">
              <div className="highlight-icon" aria-hidden="true">
                <svg viewBox="0 0 32 32" role="img" aria-label="Trusted Representation">
                  <path d="M16 2l-14 6v8c0 5.25 3.5 12.5 14 16 10.5-3.5 14-10.75 14-16v-8l-14-6zm-2 19l-5-5 1.41-1.41L14 18.17l7.59-7.59L23 12l-9 9z" />
                </svg>
              </div>
              <span className="highlight-label">Trusted Representation</span>
            </div>
          </div>
        </div>

        <div className="about-visual">
          <div className="about-photo-frame">
            <img
              src={advocateProfile}
              alt="Senior advocate in law library"
              className="advocate-photo"
            />
            <div className="success-card">
              <div className="success-ring">
                <span>86%</span>
              </div>
              <p>
                Increase in
                <span>Success cases</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
